/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './PersonalInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { formatMasterNumber } from '../../../../shared/helpers/formatMasterNumber'

const MasterNumber = ({ t, i18n, validateMasterNumber, masterNumberValid, masterNumberError, setIsError, isOptional }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const masterNumber = useSelector((state) => state.app.personalInformation.masterNumber)

  const handleMasterNumber = (e) => {
    try {
      let masterNumberElem = e.currentTarget.value
      if (RegExp(/^[a-zA-Z0-9 ]*$/i).test(masterNumberElem)) {
        dispatch(changeObjectPropertyAction('personalInformation', 'masterNumber', masterNumberElem))
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurMasterNumber = (e) => {
    try {
      SetIsFocussed(false)
      let element = e.currentTarget.value
      if (RegExp(/^[a-zA-Z0-9 ]{10,14}$/i).test(element) && RegExp(/^[a-zA-Z]*$/i).test(element[0])) {
        const masterNum = formatMasterNumber(element)
        dispatch(changeObjectPropertyAction('personalInformation', 'masterNumber', masterNum.trim().toUpperCase()))
        validateMasterNumber(masterNum.trim())
      } else {
        dispatch(changeObjectPropertyAction('personalInformation', 'masterNumber', element.trim().toUpperCase()))
        validateMasterNumber(element.trim())
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const helpURL = i18n.language === "en"
    ? "https://support.novascotia.ca/services/address-changes#finding-master-number-driver"
    : "https://support.novascotia.ca/services/address-changes-fr#finding-master-number-driver"

  return (
    // <div className={styles['fields_margin']}>
    //   <div
    //     className={
    //       masterNumberValid === true
    //         ? masterNumber === ''
    //           ? ''
    //           : 'form-group has-success'
    //         : masterNumberValid === false
    //           ? 'form-group has-error'
    //           : ''
    //     }
    //   >
    //     <label className="control-label" htmlFor="MasterNumber">
    //       {t('personal_info.master_number')}
    //     </label>
    //     <input
    //       type="text"
    //       id="MasterNumber"
    //       className="form-control"
    //       value={masterNumber}
    //       onChange={handleMasterNumber}
    //       onFocus={() => SetIsFocussed(true)}
    //       onBlur={onBlurMasterNumber}
    //       autoComplete="off"
    //       maxLength="14"
    //     />
    //     {masterNumberValid === true ? (
    //       masterNumber === '' ? (
    //         ''
    //       ) : (
    //           <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
    //         )
    //     ) : masterNumberValid === false ? (
    //       <React.Fragment>
    //         <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
    //         <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(masterNumberError)}</div>
    //       </React.Fragment>
    //     ) : (
    //           ''
    //         )}
    //   </div>
    //   <div className="help-field">{t('personal_info.this_is_needed')}</div>
    // </div>
    <div className={[
      masterNumberValid === true
        ? masterNumberValid === ''
          ? ''
          : 'form-group has-success'
        : masterNumberValid === false
          ? 'form-group has-error'
          : '',
      styles['fields_margin'],
    ].join(' ')}>
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor="MasterNumber">
          {t('personal_info.master_number')}
          {isOptional && ' ' + t('personal_info.if_applicable')}
        </label>
      </div>
      <div id="master-number-hint" className="ns-hint">
        {t('personal_info.you_can')}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={helpURL}
        >
          {' '}
          {t('personal_info.find_this')}
          <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
        </a>.
      </div>
      {(masterNumberValid === true || masterNumberValid === '') ? (
        null
      ) :
        (
          <span id="master-number-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
            <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
            <span className="ns-visually-hidden">{t('shared.error')}</span> {t(masterNumberError)}
          </span>
        )}
      <div style={{ display: "flex", overflow: "auto" }}>
        <input className={[
          'fw-20',
          (masterNumberValid === true) ? 'ns-input--success' : '',
          (masterNumberValid !== true && masterNumberValid !== '') ? 'ns-input--error' : ''].join(' ')}
          style={{ flexGrow: 1, minWidth: "3em" }}
          id="MasterNumber" name="MasterNumber" type="text"
          aria-describedby="master-number"
          onChange={handleMasterNumber}
          onBlur={onBlurMasterNumber}
          onFocus={() => SetIsFocussed(true)}
          value={masterNumber}
          autoComplete="off"
          maxLength="14" />
        {(masterNumberValid === true) && (
          <div style={{ display: "inline-flex", marginLeft: "1rem", alignItems: "center" }} ><i className="fa fa-check-circle fa-lg" aria-hidden="true"></i></div>
        )}
      </div>
    </div >
  )
}

export default withTranslation('common')(MasterNumber)